export default __webpack_public_path__ + "static/media/clearance-blue.1f1b4532.svg";